import { render, staticRenderFns } from "./UtrHome.vue?vue&type=template&id=040d7c15&scoped=true&"
import script from "./UtrHome.vue?vue&type=script&lang=js&"
export * from "./UtrHome.vue?vue&type=script&lang=js&"
import style0 from "./UtrHome.vue?vue&type=style&index=0&id=040d7c15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040d7c15",
  null
  
)

export default component.exports